import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { searchActiveLoadsBackend } from './search-active-loads.backend';
import { searchActiveLoadsReducer } from './search-active-loads.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('searchActiveLoads', searchActiveLoadsReducer),
    BackendModule.forFeature('searchActiveLoads', searchActiveLoadsBackend),
  ],
})
export class DatastoreSearchActiveLoadsModule {}
